import CommonItemCardLayout from './commonItemCardLayout'

export default CommonItemCardLayout
